import type { QueryClient } from '@tanstack/react-query';
import type { OneOnOneColleagueDetail, OneOnOneColleagueItem } from '@/lib/colleagues.ts';

/**
 * Show a change to a colleague at once, on the Team page and on their own page
 * alike, before the server has answered. The re-read afterwards settles it.
 */
export function patchColleague(
  queryClient: QueryClient,
  colleagueId: string,
  change: Partial<OneOnOneColleagueItem>,
): void {
  queryClient.setQueriesData<OneOnOneColleagueItem[]>(
    { queryKey: ['oneOnOneColleagues'] },
    (current) =>
      current?.map((one) => (one.id === colleagueId ? { ...one, ...change } : one)),
  );
  queryClient.setQueriesData<OneOnOneColleagueDetail>(
    { queryKey: ['oneOnOneColleague'] },
    (current) =>
      current && current.colleague.id === colleagueId
        ? { ...current, colleague: { ...current.colleague, ...change } }
        : current,
  );
}
